function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { usePopper } from "react-popper";
import OutsideClickListener from "../internal/OutsideClickListener";
import { Portal } from "../Portal";
export const Popover = (props)=>{
    const { open , placement , referenceElement , onOpenChange , children , triggerElement , onOutsideClick , className , modifiers ,  } = props;
    const [popperElement, setPopperElement] = useState(null);
    const { styles  } = usePopper(referenceElement, popperElement, {
        strategy: "fixed",
        placement: placement || "left",
        modifiers
    });
    const handleOutsideClick = useCallback((event)=>{
        if (event.target !== triggerElement) {
            if (onOutsideClick) onOutsideClick(event);
            onOpenChange(false);
        }
    }, [
        onOpenChange,
        onOutsideClick,
        triggerElement
    ]);
    useEffect(()=>{
        if (children.type.preload) children.type.preload();
    }, [
        children.type
    ]);
    if (!open) return null;
    return /*#__PURE__*/ _jsx(Portal, {
        children: /*#__PURE__*/ _jsx("div", {
            ref: setPopperElement,
            style: _objectSpread({}, styles.popper, {
                zIndex: 100
            }),
            className: className,
            children: /*#__PURE__*/ _jsx(OutsideClickListener, {
                onOutsideClick: handleOutsideClick,
                children: children
            })
        })
    });
};
